import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  handleShow: (value: boolean) => void;
  currentValue?: number;
  onSave: (value: number) => void;
  isSaving?: boolean;
};

const retentionOptions = [0, 30, 90, 120];

export function CallRecordingRetentionModal(props: Props): JSX.Element {
  const { show, handleShow, currentValue, onSave, isSaving } = props;
  const [value, setValue] = useState<number>(currentValue ?? 0);

  useEffect(() => {
    if (show) setValue(currentValue ?? 0);
  }, [show, currentValue]);

  return (
    <Modal show={show} onHide={() => handleShow(false)} centered id="callRecordingRetentionModal">
      <Modal.Header closeButton>
        <Modal.Title>Retention Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label className="mb-2">Retention Days</label>
          <select
            className="form-control"
            value={value}
            onChange={(e) => setValue(Number(e.target.value))}
          >
            {retentionOptions.map((days) => (
              <option key={days} value={days}>
                {days}
              </option>
            ))}
          </select>
          <small className="form-text text-muted mt-2">
            0 means keep recordings indefinitely.
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary text-uppercase"
          onClick={() => handleShow(false)}
          disabled={isSaving}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary text-uppercase"
          onClick={() => onSave(value)}
          disabled={isSaving}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}
